import { HeartHandshake, Quote } from "lucide-react";
import { PHOTOS } from "@/data";

export const Recognition = () => {
  return (
    <section id="community" className="bg-[#0C1827] py-24 overflow-hidden" data-testid="recognition-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <span className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#F5A623]">
              Community Recognition
            </span>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white mt-3 uppercase">
              Proud to Give Back
            </h2>
            <div className="mt-8 bg-[#142234] border-l-4 border-[#F5A623] rounded-r-2xl p-7">
              <Quote size={26} className="text-[#F5A623]/60 mb-4" />
              <p className="text-lg text-slate-200 leading-relaxed italic">
                "To Almaguin Yard Solutions for donating their machinery and time to create the
                sitting area base."
              </p>
              <footer className="mt-5 pt-4 border-t border-[#1E324A]">
                <p className="font-display font-bold text-white text-sm">
                  Magnetawan Horticultural Society
                </p>
                <p className="text-xs text-slate-400 mt-0.5">
                  Public thank-you sign at the community sitting area
                </p>
              </footer>
            </div>
            <p className="mt-6 text-base text-slate-300 leading-relaxed">
              When the Magnetawan Horticultural Society needed heavy equipment to build a community
              sitting area, we donated our machinery and time to get it done. This sign stands on
              the finished site — because for us, this region isn't just where we work. It's home.
            </p>
            <div className="mt-8 inline-flex items-center gap-3 bg-[#F5A623]/10 border border-[#F5A623]/40 rounded-full px-5 py-3">
              <HeartHandshake size={20} className="text-[#F5A623]" />
              <span className="text-sm font-semibold text-[#F5A623]">
                Local crew. Local community. Local pride.
              </span>
            </div>
          </div>

          <div className="relative order-first lg:order-last">
            <div className="absolute -top-6 -right-6 w-32 h-32 border-t-4 border-r-4 border-[#F5A623] rounded-tr-3xl" />
            <img
              src={PHOTOS.recognition}
              alt="Magnetawan Horticultural Society thank-you sign recognizing Almaguin Yard Solutions for donating machinery and time"
              className="relative rounded-2xl w-full max-h-[560px] object-cover shadow-2xl shadow-black/40"
            />
            <div className="absolute -bottom-6 -left-4 sm:-left-6 bg-[#F5A623] rounded-2xl px-6 py-5 shadow-xl">
              <div className="font-display font-black text-2xl text-[#0C1827]">Recognized</div>
              <div className="text-xs font-semibold uppercase tracking-wider text-[#0C1827]/70">
                By the Community We Serve
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
